var React = require('react');

function RU (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 0h49.2a3 3 0 0 1 3 3v16.3H.1V3a3 3 0 0 1 3-3z","style":{"fill":"#fff"},"key":0}),React.createElement("path",{"d":"M0 19.3h55.3v16.1a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V19.3z","style":{"fill":"#d52b1e"},"key":1}),React.createElement("path",{"d":"M.1 12.9h55.2v12.8H.1V12.9z","style":{"fill":"#0039a6"},"key":2}),React.createElement("path",{"d":"M3 0h49.2a3 3 0 0 1 3 3v32.4a3 3 0 0 1-3 3H3.1a3 3 0 0 1-3-3V3.1a3 3 0 0 1 3-3z","style":{"fill":"none","stroke":"#ccc","strokeWidth":".1199","strokeMiterlimit":"2.6131"},"key":3})]);
}

RU.defaultProps = {"xmlSpace":"preserve","style":{"enableBackground":"new 0 0 55.32 38.52"},"viewBox":"0 0 55.3 38.5"};

module.exports = RU;

RU.default = RU;
